import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion, useReducedMotion } from 'framer-motion';
import { homepageContent, siteContent } from '../../data/products';
import './BrandIntro.css';

const BrandIntro = () => {
  const reduce = useReducedMotion();
  const [visible, setVisible] = useState(true);
  const content = homepageContent.brandIntro;

  useEffect(() => {
    const app = document.querySelector('.App');
    document.body.classList.add('brand-intro-open');
    app?.setAttribute('inert', '');
    app?.setAttribute('aria-hidden', 'true');

    const closeIntro = () => {
      document.body.classList.remove('brand-intro-open');
      app?.removeAttribute('inert');
      app?.removeAttribute('aria-hidden');
      setVisible(false);
    };

    const timer = window.setTimeout(() => {
      closeIntro();
    }, reduce ? content.reducedMotionDurationMs : content.durationMs);

    return () => {
      window.clearTimeout(timer);
      document.body.classList.remove('brand-intro-open');
      app?.removeAttribute('inert');
      app?.removeAttribute('aria-hidden');
    };
  }, [content.durationMs, content.reducedMotionDurationMs, reduce]);

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          className="brand-intro"
          role="status"
          aria-label={`${siteContent.brand.name} ${siteContent.brand.signature}`}
          initial={{ opacity: 1 }}
          exit={{ opacity: 0, scale: reduce ? 1 : 1.015 }}
          transition={{ duration: reduce ? 0.12 : 0.28, ease: 'easeOut' }}
        >
          <div className="brand-intro-inner">
            <motion.div
              className="brand-intro-logo-stage"
              initial={reduce ? false : { opacity: 0, scale: 0.84, rotateX: 10, rotateY: -12, y: 14 }}
              animate={{ opacity: 1, scale: 1, rotateX: 0, rotateY: 0, y: 0 }}
              transition={{ type: 'spring', stiffness: 210, damping: 22, mass: 0.72 }}
            >
              <img
                className="brand-intro-logo"
                src={siteContent.brand.logo}
                alt=""
                aria-hidden="true"
              />
            </motion.div>
            <motion.div
              className="brand-intro-signature"
              initial={reduce ? false : { opacity: 0, clipPath: 'inset(0 100% 0 0)' }}
              animate={{ opacity: 1, clipPath: 'inset(0 0% 0 0)' }}
              transition={{ duration: 0.58, delay: reduce ? 0 : 0.2, ease: [0.22, 1, 0.36, 1] }}
            >
              {siteContent.brand.signature}
            </motion.div>
            <motion.i
              className="brand-intro-stroke"
              aria-hidden="true"
              initial={reduce ? false : { scaleX: 0 }}
              animate={{ scaleX: 1 }}
              transition={{ duration: 0.46, delay: reduce ? 0 : 0.38, ease: [0.22, 1, 0.36, 1] }}
            />
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default BrandIntro;
